// extracted by mini-css-extract-plugin
export default {"profile-modal__header":"Profile_profile-modal__header__C0DOJ"};